'use client'

export default function ViewAbout() {
  return (
    <div className="font-inter">
      <div className="text-[30px] font-semibold">About</div>
      <div className="mt-4 text-[16px] text-neutral-blue-500"></div>
    </div>
  )
}
